import React, { useCallback } from 'react';
import {
	Box,
	Label,
	Flex,
	Radio,
} from '@ascension/web';
import PreAdmitTestSubform from './PreAdmitTestSubform/PreAdmitTestSubform';
import { useFieldFormContext } from '../../../utilities/hooks/useFieldFormContext/useFieldFormContext';
import { PreAdmitTestDetailsProps } from './PreAdmitTestDetailsProps';
import { YesNoAnswer } from '../../../interfaces/SurgeryRequest/YesNoAnswer';
import { StatefulSelect } from '@components/StatefulInputs/StatefulSelect/StatefulSelect';
import { SelectOption } from '@components/StatefulInputs/StatefulSelect/StatefulSelect.types';
import { createStyles, makeStyles } from '@mui-core-real';

const useStyles = makeStyles((theme) =>
	createStyles({
		select: {
			'width': '100%',
			'padding': theme.spacing(2, 0, 2, 0),
			'& .MuiInputLabel-root': {
				fontSize: '0.75rem',
				paddingBottom: theme.spacing(0.15),
				color: theme.palette.common.black,
				fontWeight: 550,
			},
			'& .MuiSelect-select > span': {
				fontSize: '1rem',
				color: theme.palette.grey[500],
			},
		},
	}),
);

const bedNeededOptions: SelectOption[] = [
	{ label: 'Direct Admit', value: 'Direct Admit' },
	{ label: 'Pre-Hospital Bed', value: 'Pre-Hospital Bed' },
	{ label: 'None Needed', value: 'None Needed' },
];

const PreAdmitTestDetails = ({ isEdit }: PreAdmitTestDetailsProps) => {
	const classes = useStyles();
	const {
		currentValue: patTestingNeeded,
		setCurrentValue: patTestingNeededSetCurrentValue,
	} = useFieldFormContext<string>('patTestingNeeded');

	const handleRadioYes = useCallback((checked: boolean) => {
		if (checked) {
			patTestingNeededSetCurrentValue(YesNoAnswer.YES);
		}
	}, [patTestingNeededSetCurrentValue]);

	const handleRadioNo = useCallback((checked: boolean) => {
		if (checked) {
			patTestingNeededSetCurrentValue(YesNoAnswer.NO);
		}
	}, [patTestingNeededSetCurrentValue]);

	return (<>
		<Box data-field="PAT_BedNeeded">
			<StatefulSelect
				label="IS A PRE-HOSPITAL BED NEEDED?"
				placeholder="Select"
				name="patBedNeeded"
				dataField="procedureForm-patBedNeeded"
				options={bedNeededOptions}
				wrapperClassName={classes.select}
				controllerOptions={{}}
			/>
		</Box>
		<Box data-field="PAT_TestingNeeded" pt={8}>
			<Label>Is pre-admission testing needed</Label>
			<Flex flexDirection="row">
				<Box pr={5}>
					<Radio
						name="patTestingNeeded"
						key="Yes"
						label="Yes"
						value="Yes"
						checked={patTestingNeeded === YesNoAnswer.YES || false}
						onChange={handleRadioYes}
					/>
				</Box>
				<Radio
					name="patTestingNeeded"
					key="No"
					label="No"
					value="No"
					checked={patTestingNeeded === YesNoAnswer.NO || false}
					onChange={handleRadioNo}
				/>
			</Flex>
		</Box>
		{patTestingNeeded === YesNoAnswer.YES &&
			<PreAdmitTestSubform isEdit={isEdit}/>
		}
	</>);
};

export default PreAdmitTestDetails;
